import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import Switch from '@rio-cloud/rio-uikit/lib/es/Switch';
import Tooltip from '@rio-cloud/rio-uikit/lib/es/Tooltip';
import OverlayTrigger from '@rio-cloud/rio-uikit/lib/es/OverlayTrigger';

interface DownloadStatusFormItemProps {
    value?: boolean;
    onChange: (value: boolean) => void;
}

const DownloadStatusFormItem: React.FC<DownloadStatusFormItemProps> = ({
    value,
    onChange
}) => {
    useEffect(() => {
        if (value === undefined) {
            onChange(true);
        }
    }, []);

    return (
        <div className='display-flex align-content-center padding-top-5'>
            <div className=' text-right min-width-100'>
                <label>
                    <FormattedMessage id='intl-msg:downloadStatus:showOnlyActiveFiles'/>
                </label>
                <OverlayTrigger
                    key={1}
                    placement={'top'}
                    overlay={
                        <Tooltip id='tooltip' allowOnTouch>
                            <FormattedMessage id={'intl-msg:downloadStatus:showOnlyActiveFiles:tooltip'}/>
                        </Tooltip>
                    }
                >
                    <span className={'rioglyph rioglyph-exclamation-sign text-color-info margin-left-5'}/>
                </OverlayTrigger>
            </div>
            <div className='margin-left-15 margin-right-15'>

                <Switch
                    checked={value || false}
                    onChange={onChange}
                />
            </div>
        </div>
    );
};

export default DownloadStatusFormItem;
